import React from 'react';
import { Link } from 'react-router-dom';
import { campanhaNatalAtiva, campanhaSetembroAtiva } from '../utils/campanhas';
import { linkWhatsApp, MENSAGEM_VALE_PRESENTE } from '../utils/contactos';
import { registarEvento } from '../utils/analytics';

export default function AnnouncementBar() {
  if (campanhaNatalAtiva()) {
    return (
      <div className="text-center text-sm font-medium py-2 px-4" style={{ backgroundColor: '#B89547', color: '#2E2C29' }}>
        🎁 Neste Natal, ofereça bem-estar: vale-presente Márcia Monteiro Wellness.{' '}
        <a href={linkWhatsApp(MENSAGEM_VALE_PRESENTE)} target="_blank" rel="noopener noreferrer" onClick={() => registarEvento('clique_whatsapp', { origem: 'barra_vale_presente' })} className="underline font-semibold">Oferecer →</a>
      </div>
    );
  }
  if (!campanhaSetembroAtiva()) return null;
  return (
    <div className="text-center text-sm font-medium py-2 px-4" style={{ backgroundColor: '#B89547', color: '#2E2C29' }}>
      🎉 Em Setembro, inscreva-se nas aulas de Yoga ou Pilates sem pagar a inscrição.{' '}
      <Link to="/servicos" className="underline font-semibold">Saber mais →</Link>
    </div>
  );
}
